import { useMemo } from 'react';
import styles from './PlanCard.module.scss';
import { usePaymentControlState, useSubscriptionInfo } from 'src/hooks';
import { PlanKind, SubscriptionPlanInfo } from 'src/types';
import { PlanCardTitle } from 'src/pages/PaymentBetaPage/componentsV2/PlanCardTitle';
import { PlanCardPrice } from 'src/pages/PaymentBetaPage/componentsV2/PlanCardPrice';
import { PlanCardDescription } from 'src/pages/PaymentBetaPage/componentsV2/PlanCardDescription';
import { GetPlanButton } from 'src/pages/PaymentBetaPage/componentsV2/GetPlanButton';
import { SelectedPlanButton } from 'src/pages/PaymentBetaPage/components/SelectedPlanButton';
import { PlanCardContent } from '../PlanCardContent';
import { UserTier } from 'src/types/wallet/models/UserTier';

interface PlanCardProps {
  sectionPlan: SubscriptionPlanInfo;
  onOpenCheckout: () => void;
}

export const PlanCard = ({ sectionPlan, onOpenCheckout }: PlanCardProps) => {
  const { plan_kind, plan_family, plan_tier } = sectionPlan;
  const { selectedPlan } = usePaymentControlState();
  const { subscriptionInfo } = useSubscriptionInfo();

  const subscribedTier = useMemo(() => {
    return subscriptionInfo?.plan_tier;
  }, [subscriptionInfo]);

  const isCurrentPlan = useMemo(() => {
    return subscriptionInfo?.plan_kind === plan_kind;
  }, [subscriptionInfo, plan_kind]);

  const isSelected = selectedPlan === plan_kind;

  return (
    <div className={styles.root}>
      <div className={styles.mainContainer}>
        <div className={styles.headerWrapper}>
          {/* There is a bug with type generation. SubscriptionPlanInfo.plan_kind has to be the PlanKind type, not string */}
          <PlanCardTitle planKind={plan_kind as PlanKind} />

          <PlanCardPrice sectionPlan={sectionPlan} />
        </div>
        <div className={styles.buttonWrapper}>
          {isSelected ? (
            <SelectedPlanButton />
          ) : (
            <GetPlanButton
              isCurrentPlan={isCurrentPlan}
              isSubscribedTier={!!subscribedTier}
              planFamily={plan_family}
              planKind={plan_kind as PlanKind}
              onOpenCheckout={onOpenCheckout}
            />
          )}
        </div>
        <PlanCardDescription />
        <PlanCardContent
          planFamily={plan_family}
          planKind={plan_kind as PlanKind}
          planTier={plan_tier as unknown as UserTier}
        />
      </div>

      <p className={styles.footerCaption}>
        Cancel anytime, effective next billing cycle
      </p>
    </div>
  );
};
